import React, { useState } from 'react';
import PropTypes from 'prop-types';

/**
 * CategoryTag Component
 * Displays a category with appropriate color, icon, and name
 */
const CategoryTag = ({ category, onClick, className = '', confidence }) => {
  const [isHovered, setIsHovered] = useState(false);
  
  // Default values in case category is null or incomplete
  const categoryName = category?.name || 'Uncategorized';
  const categoryColor = category?.color || '#94A3B8'; // Default gray
  const categoryIcon = category?.icon || 'tag';
  
  // Format the confidence score if present
  const formattedConfidence = confidence ? `${Math.round(confidence * 100)}%` : '';
  
  return (
    <div 
      className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium ${className}`} 
      style={{ 
        backgroundColor: `${categoryColor}30`, // 30% opacity of the color
        color: categoryColor,
        borderColor: `${categoryColor}70`, // 70% opacity for border
        borderWidth: '1px',
        cursor: onClick ? 'pointer' : 'default',
        minWidth: '80px',
        textAlign: 'center',
        justifyContent: 'center'
      }}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      role={onClick ? 'button' : 'presentation'}
      title={onClick 
        ? `Click to change category from ${categoryName}${formattedConfidence ? ` (${formattedConfidence} confidence)` : ''}` 
        : `${categoryName}${formattedConfidence ? ` (${formattedConfidence} confidence)` : ''}`}
    >
      <span className="mr-1 text-xs">
        {/* We'll use a simple ● symbol for now, but could be replaced with proper icons */}
        ●
      </span>
      {categoryName}
      {isHovered && confidence > 0 && (
        <span className="ml-1 text-xs font-medium">
          ({formattedConfidence})
        </span>
      )}
    </div>
  );
};

CategoryTag.propTypes = {
  category: PropTypes.shape({
    _id: PropTypes.string,
    name: PropTypes.string,
    color: PropTypes.string,
    icon: PropTypes.string
  }),
  onClick: PropTypes.func,
  className: PropTypes.string,
  confidence: PropTypes.number
};

export default CategoryTag; 